import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './components/auth/LoginPage';
import PageShell from './components/layout/PageShell';
import OverviewPage from './components/pages/OverviewPage';
import BatteriesPage from './components/pages/BatteriesPage';
import InvertersPage from './components/pages/InvertersPage';
import ChillersPage from './components/pages/ChillersPage';
import DehumidifiersPage from './components/pages/DehumidifiersPage';
import './App.css';

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />}
      />
      <Route
        element={
          <ProtectedRoute>
            <PageShell />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<OverviewPage />} />
        <Route path="/batteries" element={<BatteriesPage />} />
        <Route path="/inverters" element={<InvertersPage />} />
        <Route path="/chillers" element={<ChillersPage />} />
        <Route path="/dehumidifiers" element={<DehumidifiersPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
